import { compose, concat, __, isEmpty, isNil, either, toString } from "ramda"

export default {
  filters: {
    toPercentage: (value) => {
      const hasValue = either(isEmpty, isNil)(value)
      if (hasValue) { return '' }
      const percentageValue =  compose(concat(__, '%'), toString)(value)

      return percentageValue
    }
  }
}
